import { useSelector } from "react-redux";

const useGlobalLoading = () => {
  const {
    auth,
    Media,

  } = useSelector((state) => state);

  return (
    auth.loading ||
    // myProfile.loading ||
    Media.loading
  );
};

export default useGlobalLoading;
